export const EMERGENCY_SORENSON_DOMAIN_PATTERN =
  /sip:(?:\+?)(911\d*)@unregistered\.sorenson\.com(:\d+)?(;.*)?/i;

// Pattern 2: More comprehensive pattern that checks for emergency calls from various domains:
// - p.ci.svrs.net or p.ci-qa-c.svrs.net (production or QA environments)
// - anonymous.invalid (used for anonymous callers)
export const EMERGENCY_MULTI_DOMAIN_PATTERN =
  /sip:(?:\+?)(911\d*)@(?:p\.ci(?:-qa-c)?\.svrs\.net|anonymous\.invalid)(:\d+)?(;.*)?/i;
